import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import Searchbar from './components/Searchbar';
import {A4map} from './hearbymap/src/A4map/A4map';
import {setMapHtml} from './indexHelper/index';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import './hearbymap/src/css/hearby-widget-map-1.0.css';
import './carousel-react/src/css/hearby-widget-reactcarousel-old.css';
import './hearby-widget-powersearchbar-1.1.css';
import SimpleSlider from './carousel-react/src/components/carousel';
import { mainCarouselConfigObj, liveStreamCarouselConfigObj } 
  from './carouselConfigObj';
import {getUrlParam} from './utils/url';
import { isValid } from './utils/validate';


const theme = window.powersearchUserSettings.theme;

(async function () {
  const settings = window.powersearchUserSettings;
  setMapHtml(window.powersearchUserSettings);
  /**
   * Init Map on 'js-map'
   * Add API Key
   */
  window.aMap = new A4map({
    gApiKey: 'AIzaSyAQCEUvub3Z1INT7fJqrnyJPcmbPOShK4A',
    menuOptions: { search: true, eventPopUp: true },
    loc: { lat: settings.defaultLocation.lat, lng: settings.defaultLocation.lon },
    distance: settings.powersearchBarOpts.distanceOpts.defaultDistance,
  });
  window.aMap.init();

  //window.setMap = setMapMarkers;
  
const powersearchClass = `hearby-powersearch-widget hearby-cw-theme-${theme}`;
const carouselClass = `hearby-carousel-widget hearby-cw-theme-${theme}`;

// const eventGuidLink = '3e33b02f-c387-11eb-945c-12759cb8ec5b';
// ?event_guid=a60702b7-7d92-428e-9686-e2a94a6bed34&lat=34.052235&lon=-118.243683
// ?event_guid=e57d9c09-532a-46cf-bb1c-1b41ef460b2b&lat=34.052235&lon=-118.243683

const lonFromURL = getUrlParam('lon');
const eventGuidLink = getUrlParam('event_guid');
const latFromURL = getUrlParam('lat');
const sharedEventParams = {
  'event_guid': eventGuidLink,
  'lat': latFromURL,
  'lon': lonFromURL
}

ReactDOM.render(
  <React.StrictMode>
    <div className={powersearchClass}>
      {/* {console.log('index.js sharedEventParams: ', sharedEventParams)} */}
      <Searchbar settings={settings} sharedEventParams={sharedEventParams}/>
    </div>
  </React.StrictMode>,
  document.getElementById(settings.powersearchId)
);

ReactDOM.render(
  <React.StrictMode> 
      <div className={carouselClass}>
        <SimpleSlider 
          mainCarouselConfigObj={mainCarouselConfigObj} 
          sharedEventParams={sharedEventParams} />
      </div>
  </React.StrictMode>,
  document.getElementById(settings.carouselId),
);

// partner widget path
// '/wp-content/plugins/a4powersearch-wp/powersearch/build'
// hearby home path
// '/wp-content/plugins/hearby-filters-react/powersearch-new/build'
}) ();
